import React from 'react';
import DashboardGrid from '../features/dashboard/DashboardGrid';

const AdminDashboard = () => <DashboardGrid kind="admin" />;

export default AdminDashboard;
